global.$ = global.jQuery = require('jquery');
import 'bootstrap';
import 'select2';
import {Application} from '@hotwired/stimulus';
import {definitionsFromContext} from '@hotwired/stimulus-webpack-helpers';
import ApplicationController from "./controllers/application_controller";

!function () {
    if (global.jQuery && global.jQuery.fn && global.jQuery.fn.select2 && global.jQuery.fn.select2.amd) var e = global.jQuery.fn.select2.amd;
    e.define("select2/i18n/hu", [], function () {
        return {
            errorLoading: function () {
                return "Az eredmények betöltése nem sikerült."
            }, inputTooLong: function (e) {
                return "Túl hosszú. " + (e.input.length - e.maximum) + " karakterrel több, mint kellene."
            }, inputTooShort: function (e) {
                return "Túl rövid. Még " + (e.minimum - e.input.length) + " karakter hiányzik."
            }, loadingMore: function () {
                return "Töltés…"
            }, maximumSelected: function (e) {
                return "Csak " + e.maximum + " elemet lehet kiválasztani."
            }, noResults: function () {
                return "Nincs találat."
            }, searching: function () {
                return "Keresés…"
            }, removeAllItems: function () {
                return "Távolítson el minden elemet"
            }
        }
    }), e.define, e.require
}();

window.application = Application.start();
window.Controller = ApplicationController;

const context = require.context('./controllers', true, /\.js$/);
application.load(definitionsFromContext(context));
